import React, { useEffect, useState } from 'react';
import { useParams, Link} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Composants Bootstrap
import { Carousel, Button, Modal } from 'react-bootstrap';
import StoreLayout from '../../components/layout/StoreLayout';
import { getProductById, getProducts } from '../../redux/actions/productActions';
import { addToCart } from '../../redux/actions/cartActions';

const ProductDetailPage = () => {
  const { productId } = useParams();
  const dispatch = useDispatch();
  // const navigate = useNavigate()

  const { currentProduct, products, loading, error: productError } = useSelector((state) => state.products);
  const { categories } = useSelector((state) => state.categories);
  // const { items: cartItems } = useSelector((state) => state.cart);

  const [quantity, setQuantity] = useState(1);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showFullscreen, setShowFullscreen] = useState(false);

  // Récupérer le produit
  useEffect(() => {
    if (productId) {
      dispatch(getProductById(productId));
      dispatch(getProducts());
    }
  }, [productId, dispatch]);

  // Trouver les produits similaires
  useEffect(() => {
    if (currentProduct && currentProduct.category) {
      const related = products.filter(

        (p) =>
          (p.category === currentProduct.category || p.category?._id === currentProduct.category?._id) &&
          p._id !== currentProduct._id
      );
      setRelatedProducts(related.slice(0, 8));
    }
  }, [currentProduct, products]);

  const handleAddToCart = () => {
    setIsAddingToCart(true);
    dispatch(addToCart(currentProduct, quantity));

    setTimeout(() => {
      setIsAddingToCart(false);
      setShowToast(true);
    }, 500);
  };

  const increaseQty = () => setQuantity((q) => (q < 100 ? q + 1 : 100));

  const decreaseQty = () => setQuantity((q) => Math.max(1, q - 1));

  const category = categories.find(
    (cat) => cat._id === currentProduct?.category?._id || cat._id === currentProduct?.category
  );

  if (loading) {
    return (
      <StoreLayout>
<div className="container my-5 py-5">
        <div className="row">
          {/* Image du produit */}
          <div className="col-md-6 mb-4">
            <div
              style={{
                backgroundColor: "#f0f0f0",
                height: "400px",
                borderRadius: "10px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>
          </div>

          {/* Informations du produit */}
          <div className="col-md-6">
            <div
              style={{
                height: "25px",
                width: "60%",
                backgroundColor: "#e0e0e0",
                borderRadius: "5px",
                marginBottom: "20px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>

            <div
              style={{
                height: "18px",
                width: "40%",
                backgroundColor: "#e0e0e0",
                borderRadius: "5px",
                marginBottom: "10px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>

            <div
              style={{
                height: "15px",
                width: "90%",
                backgroundColor: "#e0e0e0",
                borderRadius: "5px",
                marginBottom: "8px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>

            <div
              style={{
                height: "15px",
                width: "85%",
                backgroundColor: "#e0e0e0",
                borderRadius: "5px",
                marginBottom: "8px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>

            <div
              style={{
                height: "15px",
                width: "75%",
                backgroundColor: "#e0e0e0",
                borderRadius: "5px",
                marginBottom: "20px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>

            <div
              style={{
                height: "45px",
                width: "200px",
                backgroundColor: "#d6d6d6",
                borderRadius: "8px",
                animation: "pulse 1.5s infinite",
              }}
            ></div>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0% { background-color: #f0f0f0; }
            50% { background-color: #e0e0e0; }
            100% { background-color: #f0f0f0; }
          }
        `}
      </style>
      </StoreLayout>
    );
  }

  if (!currentProduct && !loading && productError) {
    return (
      <StoreLayout>
        <div className="container py-5">
          <div className="alert alert-danger text-center">
            {productError || 'Produit introuvable'}
          </div>
          <div className="text-center">
            <Link to="/products" className="btn btn-outline-primary">
              ← Retour aux produits
            </Link>
          </div>
        </div>
      </StoreLayout>
    );
  }

  return (
    <StoreLayout>
      <div className="container py-5">
        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Accueil</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/products">Produits</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {currentProduct?.name}
            </li>
          </ol>
        </nav>

        {/* Fiche produit */}
        <div className="row g-4">
          {/* Galerie d'images */}
          <div className="col-md-6">
            {currentProduct?.images && currentProduct.images.length > 0 ? (
              <div >
                <Carousel variant="dark" indicators={true} controls={true}>
                  {currentProduct.images.map((img, index) => (
                    <Carousel.Item key={index}>
                      <img onClick={() => setShowFullscreen(true)} style={{ cursor: "pointer" }}
                        src={img}
                        alt={`${currentProduct.name} - Image ${index + 1}`}
                        className="d-block w-100"
                        style={{ height: '400px', objectFit: 'contain' }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            ) : (
              <div className="bg-light border rounded p-5 text-center">
                <p>Aucune image disponible pour ce produit.</p>
              </div>
            )}
          </div>




          {/* Informations produit */}
          <div className="col-md-6">
            <h2 className="mb-3">{currentProduct?.name}</h2>
            <p className="text-muted mb-1">
              Catégorie : <strong>{category?.name || 'Inconnue'}</strong>
            </p>
            <h4 className="text-danger mb-4">{currentProduct && currentProduct?.price ? currentProduct?.price.toFixed(0) : 0} F</h4>
            <p className="mb-4">{currentProduct?.description || 'Aucune description.'}</p>

            {/* Quantité */}
            <div className="d-flex align-items-center mb-4">
              <label className="me-3">Quantité :</label>
              <div className="input-group w-auto" style={{ maxWidth: '200px' }}>
                <button className="btn btn-outline-secondary font-bold" onClick={decreaseQty}>
                  -
                </button>
                <input
                  type="number"
                  className="form-control text-center"
                  value={quantity}
                  readOnly
                  style={{ width: '80px' }}
                />
                <button className="btn btn-outline-secondary font-bold" onClick={increaseQty}>
                  +
                </button>
              </div>
            </div>

            {/* Bouton ajout au panier */}
            <Button
              size="lg"
              variant="danger"
              onClick={handleAddToCart}
              disabled={isAddingToCart}
              className={`w-100 ${isAddingToCart ? 'disabled' : ''}`}
            >
              {isAddingToCart ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" /> Ajout...
                </>
              ) : (
                <>
                  <i className="bi bi-cart me-2"></i> Ajouter au panier
                </>
              )}
            </Button>
          </div>
        </div>


        {/* Description complète */}
        {/* <div className="mt-5 bg-light p-4 rounded">
          <h5>Description complète</h5>
          <p className="mt-2">{currentProduct?.description || 'Aucune description disponible.'}</p>
        </div> */}

        {/* Produits similaires */}
        {relatedProducts.length > 0 && (
          <div className="mt-5" style={{ paddingTop: "100px" }}>
            <h4 className="mb-3">Autres produits similaire</h4>
            <div className="row g-4">
              {relatedProducts.map((prod) => (
                <div key={prod._id} className="col-md-3">
                  <div className="card h-100 shadow-sm border-0">
                    <img
                      src={prod.images?.[0] || '/default-product.jpg'}
                      alt={prod.name}
                      className="card-img-top"
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <div className="card-body d-flex flex-column">
                      <h6 className="card-title">{prod.name}</h6>
                      <p className="card-text text-danger">{prod && prod?.price ? prod?.price.toFixed(0) : 0} F</p>
                      <span
                        onClick={() => {
                          window.location.href = `/product/${prod._id}`;
                          // navigate(`/product/${prod._id}`);
                        }}
                        className="btn btn-sm btn-outline-danger mt-auto"
                      >
                        Voir ce produit
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}


        {/* Toast feedback */}
        {showToast && (
          <div className="position-fixed bottom-0 end-0 m-3 p-3" style={{ zIndex: 9999 }}>
            <div className="toast show align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
              <div className="d-flex">
                <div className="toast-body d-flex align-items-center">
                  <i className="bi bi-check-circle-fill me-2"></i>
                  <strong>{currentProduct?.name}</strong> ajouté au panier !
                </div>
                <button
                  type="button"
                  className="btn-close me-2"
                  data-bs-dismiss="toast"
                  aria-label="Close"
                  onClick={() => setShowToast(false)}
                ></button>
              </div>
            </div>
          </div>
        )}


        {/* Modale plein écran */}
        <Modal
          show={showFullscreen}
          onHide={() => setShowFullscreen(false)}
          fullscreen
          centered
          
        >
          <Modal.Header closeButton className="border-0 bg-white">
            <Modal.Title className="text-dark">
              {currentProduct?.name || ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <Carousel variant="white" indicators={true} controls={true}>
              {currentProduct && currentProduct?.images && currentProduct?.images.length > 0 && currentProduct?.images?.map((img, index) => (
                <Carousel.Item key={index}>
                  <img
                    src={img}
                    alt={`${currentProduct.name} - Image ${index + 1}`}
                    className="d-block w-100"
                    style={{
                      height: "100vh",
                      objectFit: "contain",
                      backgroundColor: "#000",
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal.Body>
        </Modal>
      </div>
    </StoreLayout>
  );
};

export default ProductDetailPage;